import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer';
import ConfigReducer from './ConfigReducer';
import LiveReducer from './LiveReducer';
import PlaybackReducer from './PlaybackReducer';
// import PreviewReducer from './PreviewReducer';
import DataReducer from './DataReducer';
import AdminReducer from './AdminReducer';

const rootReducer = combineReducers({
    auth: AuthReducer,
    config: ConfigReducer,
    live: LiveReducer,
    playback: PlaybackReducer,
    // preview: PreviewReducer,
    data: DataReducer,
    admin: AdminReducer
});

export default rootReducer;